<template>
  <div>
    <v-menu
      offset-y
      full-width
      v-model="menu"
      :close-on-content-click="false"
      nudge-top="24"
    >
      <v-autocomplete
        :label="label"
        item-text="name"
        item-value="dbid"
        v-model="deptRoleIds"
        :items="deptRoles"
        :hide-selected="true"
        :multiple="true"
        append-icon="add"
        @click:append="onMenu"
        :hint="hint"
        persistent-hint="persistent-hint"
        slot="activator"
        :menu-props="{contentClass:'hide-list'}"
        :rules="xRules.deptRoles"
      >
        <template slot="selection" slot-scope="data">
          <v-chip
            close
            @input="onDelSeclect(data.item.dbid)"
            :selected="data.selected"
            class="chip--select-multi"
            :key="data.item.dbid"
            small
          >
            {{data.index + 1}}. {{ data.item.department.name }}({{data.item.role.name}})
          </v-chip>
        </template>
      </v-autocomplete>

      <v-card>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-autocomplete
                  label="部门"
                  item-text="name"
                  item-value="dbid"
                  clearable
                  :loading="deptLoading"
                  :items="deptItems"
                  v-model="dept"
                  @change="onDeptChange"
                  hint="输入关键词，按回车键检索，并选择部门。"
                  persistent-hint
                />
              </v-flex>
              <v-flex xs12>
                <v-divider/>
                <h4 class="caption">部门角色</h4>
                <v-checkbox
                  v-for="r in roleItems"
                  :key="r.dbid"
                  v-model="roles"
                  :label="r.role.name"
                  :value="r"
                  hide-details
                />
              </v-flex>
            </v-layout>
          </v-container>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="menu = false">关闭</v-btn>
          <v-btn color="primary" :disabled="roles.length <= 0" @click="onAddRole">添加</v-btn>
        </v-card-actions>

      </v-card>
    </v-menu>
  </div>
</template>
<script>
  export default {
    props: ['value', 'label', 'hint', 'persistent-hint', "rules"],

    data() {
      return {
        deptUri: '/api/syst/department',
        deptRoleUri: '/api/syst/dept-role',

        menu: false,

        loading: false,

        rank: 0,
        deptRoleIds: [],
        deptRoles: [],

        dept: "",
        deptSearch: '',
        deptLoading: false,
        deptItems: [],

        roles: [],
        roleItems: [],

        /**
         * 验证规则
         */
        xRules: {
          deptRoles: [v => (!!v && v.length > 0) || '必填项。']
        }
      }
    },
    watch: {
      value(val) {
        if (Array.isArray(val)) {
          this.deptRoles = val;
          this.deptRoleIds = this.deptRoles.map(v => v.dbid);
        } else {
          this.deptRoles = [];
          this.deptRoleIds = [];
        }
      }
    },
    created(){
      const vm = this;
      vm.deptLoading = true;
      this.axios.get(vm.deptUri, {params:{limit: 256}})
        .then(
          rsp => {
            vm.deptLoading = false;
            vm.deptItems = rsp.data.items
          })
    },

    methods: {
      onMenu() {
        this.menu = !this.menu;
      },

      onDeptChange(v) {
        const vm = this;

        vm.roles = [];
        vm.roleItems = [];

        if (v && v.length > 0) {
          const param = window.xutil.param("departmentId", v);

          vm.deptLoading = true;
          this.axios.get(vm.deptRoleUri, {params: param})
            .then(
              rsp => {
                vm.deptLoading = false;
                vm.roleItems = rsp.data.items
              })
        }
      },

      onAddRole() {
        this.deptRoles.push(...this.roles.filter(r => !this.deptRoles.find(dr => dr.dbid === r.dbid)));

        this.deptRoleIds.push(...this.roles.map(r => r.dbid).filter(r => !this.deptRoleIds.find(dr => dr === r)));

        this.dept = '';
        this.roles = [];
        this.roleItems = [];

        this.$emit('input', this.deptRoles);

        this.menu = false
      },

      onDelSeclect(r) {
        const idx = this.deptRoleIds.findIndex(v => v === r);

        this.deptRoleIds.splice(idx, 1);
        this.deptRoles.splice(idx, 1);

        this.$emit('input', this.deptRoles);
      }

    }
  }
</script>
<style>
  div.v-menu__content.hide-list {
    display: none;
  }
</style>

